"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';
import classes from './List.module.css.mjs';

const List = forwardRef(
  ({ children, className, ...props }, ref) => {
    const { list } = dropdownRecipe();
    return /* @__PURE__ */ jsx(
      "div",
      {
        role: "list",
        "aria-label": "Options",
        className: clsx(list, classes.scrollShadow, className),
        ...props,
        ref,
        children
      }
    );
  }
);

export { List };
